import { useLocalization } from "@/hooks";

export const useDatetimeUtils = () => {
  const { i18n, locale } = useLocalization();
  const formatDuration = (seconds: number): string => {
    const hours = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const parts: string[] = [];

    if (hours > 0) {
      parts.push(i18n.t("misc.hoursShort", { count: hours }));
    }
    if (mins > 0 || hours > 0) {
      parts.push(i18n.t("misc.minutesShort", { count: mins }));
    }
    parts.push(i18n.t("misc.secondsShort", { count: secs }));

    return parts.join(" ");
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    return date.toLocaleDateString(locale, {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const formatDateTime = (date: Date | null | undefined): string => {
    if (!date) return i18n.t("misc.unknown");
    return new Intl.DateTimeFormat(locale, {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(date);
  };

  return {
    formatDate,
    formatDateTime,
    formatDuration,
  };
};
